import { getType } from 'typesafe-actions';

import { TwoFactorAuthenticationState } from '@tradingblock/types';
import { InitialState } from '../initialState';
import { RootAction, TwoFactorAuthenticationActions } from '../actions';

export const twoFactorAuthentication = (
  state = InitialState.twoFactorAuthentication,
  action: RootAction
): TwoFactorAuthenticationState => {
  switch (action.type) {
    case getType(TwoFactorAuthenticationActions.receiveDetails):
      const { payload } = action;

      return {
        ...state,
        details: {
          ...state.details,
          ...payload,
        },
      };
    default:
      return state;
  }
};
